<template>
    <div class="shop-container">
        <swiper-small :list="bannerArr"/>

				<!-- content -->
				<div class="e-contact">
					<!--<div id="googlemap" class="map relative over-hidden"></div>-->
					<div class="row">
						<div class="about">
							<div class="e-contact-address footer-about">
								<h3 class="contact-title v2">Contact Information</h3>
								<ul class="footer-block-content">
									<!-- <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Sanlida Archery Equipment Corporation</p> -->
									<li class="email">
										<span>nathan@sanlidaarchery.com</span>
									</li>
									<li class="email">
										<span>info@sanlidaarchery.com</span>
									</li>
									<!-- <li class="phone">
										<span>+86-15538955549</span>
									</li> -->
									<li class="phone">
										<span>+86-391-3216626</span>
									</li>
									<li class="address">
										<span>Sanlida Archery Culture Tourism Area,Jiaohui Road,Shanyang District,Jiaozuo,Henan, China</span>
									</li>
								</ul>
							</div>
							
							<div class="contact-info">
								<!-- <h3 class="contact-title spc">USA Repair Site</h3>
								<p style="font-weight: 600;">Western Archery</p>
								<p>Brad Love</p>
								<p>10955 County Road 128</p>
								<p>Poncha Springs , CO 81242 </p>
								<p>Tel: 1-800-525-1181 </p>
								<p>Email: snblove@wribiz.net</p>
								<br><br>
								<p style="font-weight: 600;">CJE Archery</p>
								<p>Chris Bannister</p>
								<p>258 Leaman Rd </p>
								<p>Cochranville, PA 19330</p>
								<p>Tel: 763-229-2294 </p> -->
							</div>
						</div>
						
						<div class="message">
							<h3 class="contact-title spc">How Can We Help?</h3>
							<span>We' re more than glad to help & looking forward to your feedback and question.</span>
							
								<div class="login-form">
									<div class="form-group">
										<input type="text" id="country" v-model="country" class="form-control bdr" name="country" value="" placeholder="Please Enter Your Country *">
										<input type="text" id="name" v-model="name" class="form-control bdr" name="name" value="" placeholder="Please Enter Your Name *">
										<input type="email" id="email" v-model="email" class="form-control bdr" name="email" value="" placeholder="Please Enter Your Email *">
										<textarea id="message" v-model="comment" class="form-control bdr3" name="comment" rows="10" placeholder="Please Leave Us a Massage"></textarea>
									</div>
									<div class="error" v-show="showError">
									  <i class="icon iconfont iconerror"></i>
									  {{errorText}}
									</div>
									<div class="form-group">
										<button type="button"  @click="addMessage" class="btn btn-submit btn-gradient">
											Send message
										</button>
									</div>
								</div>
							
						</div>
					</div>
				</div>
    </div>
</template>

<script>
import SwiperSmall from '@/components/common/SwiperSmall.vue'
import { inputCheckPhone, isValid } from "@/utils/index.js";
export default {
    components: {
        SwiperSmall
    },
    data() {
        return {
            bannerArr: [],
			form: {
				country: '',
				name: '', // 单位名称
				email: "", // 邮箱
				comment: ''
			},
			country: '',
			name: '',
			email: "",
			comment: '',
			country: "",
			errorText: "",
        }
    },
    mounted() {
        this.getBanner()
    },
	computed: {
		showError() {
		  return isValid(this.errorText);
		}
	},
    methods: {
        // 获取轮播图s
        getBanner() {
            this.$api.slider({
                code: 'pc_information_slide'
            }).then(res => {
                if (res.status) {
					//console.log(res.data.list);
                    this.bannerArr = res.data.list;
                }
            });
        },
        initParams() {
            let copy = JSON.parse(JSON.stringify(this.form))
            copy.where = JSON.stringify(copy.where)
            return copy
        },
		hideDialog(){
			this.country = '';
			this.name = '';
			this.email = '';
			this.comment = '';
		},
		addMessage() {
		  if (!this.country) {
			return (this.errorText = 'Please Enter Your Country');
		  }
		  
		  if (!this.name) {
			return (this.errorText = 'Please Enter Your Name');
		  }
		  
		  if (!this.email) {
			return (this.errorText = 'Please Enter Your Email');
		  }
		  
		  
		  let form = {
			id: 11,
			data: {
			  84: this.country,
			  85: this.name,
			  86: this.email,
			  87: this.comment
			}
		  }

		  if(this.$storage.get('userToken')) {
			form.token = this.$storage.get('userToken')
		  }
		 this.$api.formAddsubmit(form).then(res => {
			   if(res.status) {
				this.$message({
				  message: res.msg,
				  type: 'success'
				});
				this.hideDialog()
				this.form = {
				  country: '',
				  name: "", // 联系人
				  email: "", // 邮箱
				  comment: ''
				}
			   } else {
				this.$message({
				  message: res.msg,
				  type: 'warning'
				});
			   }
		 })
		  
	  }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';

.e-contact {
	padding-top:24px;
	padding-bottom:87px;
    background: #FFFFFF;
	margin-bottom:30px;
	
}
.e-contact .row {
	margin-bottom:36px;
	padding:0 30px;
	margin-top:0px;
	padding-top:30px;
}

.e-contact .about {
	padding-top:0px;
	margin:0px;
	margin-left:40px;
	width:550px;
	height:500px;
	display:inline-block;
}
.e-contact .message {
	width:550px;
	margin:0;
	padding:0;
	margin-left:20px;
	vertical-align:top;
	display:inline-block;
	.error {
		margin-bottom: 20px;
		font-size: 12px;
		color: $theme-color;
		transition: all 0.2s;
	}
	.btn-gradient{
		color: #fff !important;
		font-weight: 500;
		background-image: linear-gradient(122deg, #c26af5, #54f0ff);
		-webkit-transition: all 0.3s ease 0s;
		transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s; 
	} 
	.btn-gradient:hover{
		color: #fff;
		-webkit-box-shadow: 0px 2px 20px 2px rgba(194, 106, 245, 0.68);
		box-shadow: 0px 2px 20px 2px rgba(194, 106, 245, 0.68); 
	}
	span{
		font-size: 14px;
		margin-bottom: 35px;
		display: block;
	}
}

.e-contact .footer-block-content {
	margin-top:17px;
	margin-bottom:55px;
}
.e-contact .form-control {
	margin-bottom:26px;
}

.e-contact input {
	height:54px;
	border-radius:999px;
	border:1px solid #eaeaea;
	padding-left:33px;
}
.e-contact input::-webkit-input-placeholder {
	color:#999999;
	font-size:14px;
}
.e-contact input:-moz-placeholder {
	color:#999999;
	font-size:14px;
}
.e-contact input::-moz-placeholder {
	color:#999999;
	font-size:14px;
}
.e-contact input:-ms-input-placeholder {
	color:#999999;
	font-size:14px;
}
@media (min-width:1024px) {
	.e-contact input {
	width:440px;
}
}.e-contact textarea {
	border:1px solid #eaeaea;
	padding-left:33px;
	padding-top:15px;
	border-radius:22px;
	resize:none;
}
.e-contact textarea::-webkit-input-placeholder {
	color:#999999;
	font-size:14px;
}
.e-contact textarea:-moz-placeholder {
	color:#999999;
	font-size:14px;
}
.e-contact textarea::-moz-placeholder {
	color:#999999;
	font-size:14px;
}
.e-contact textarea:-ms-input-placeholder {
	color:#999999;
	font-size:14px;
}
.e-contact textarea {
	width:440px;
	padding-top:34px;
}
.e-contact textarea.form-control {
	margin-bottom:29px;
}
.e-contact .btn-submit {
	width:229px;
	height:54px;
	line-height:54px;
	border-radius:999px;
	font-size:16px;
	padding:0;
	border:0;
}

.contact-title {
	font-size:20px;
	font-weight:bold;
}
.contact-title.v2 {
	font-size:16px;
}
.contact-title.spc {
	font-size:16px;
	margin-bottom:34px;
}
.contact-info {
	margin-bottom:33px;
}
.contact-info p {
	line-height:26px;
	color:#666666;
}
.contact-info p {
	max-width:560px;
}

.footer-about ul li {
	font-size:14px;
	line-height:24px;
	padding:10px 0px 4px 32px;
	color:#666666;
}
.footer-about ul .address {
	background:url("~@/assets/icon/icon-map.png") no-repeat left top;
	background-position:left 14px;
	max-width:340px;
}
.footer-about ul .phone {
	background:url("~@/assets/icon/f-phone.png") no-repeat left top;
	background-position:left 14px;
}
.footer-about ul .email {
	background:url("~@/assets/icon/f-mail.png") no-repeat left top;
	background-position:left 14px;
}
.footer-about ul .time {
	background:url(".~@/assets/icon/f-time.png") no-repeat left top;
	background-position:left 14px;
}


</style>